var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.3,1.8H5.6c-0.1,0-0.1,0-0.1,0.1v3.7H2.1C2,5.6,2,5.6,2,5.7v0.7c0,0.1,0,0.1,0.1,0.1h3.5v3.7c0,0.1,0,0.1,0.1,0.1h0.7 c0.1,0,0.1,0,0.1-0.1V6.4h3.5c0.1,0,0.1,0,0.1-0.1V5.7c0-0.1,0-0.1-0.1-0.1H6.4L6.3,1.8C6.4,1.8,6.4,1.8,6.3,1.8z"
  })));
};
export default SvgPlus;